import { HPMSOnClickLink } from '@philips-emr/hpms-health-insurance-components';
import { ThemeTonalRange } from '@philips-emr/tws-constants';
import Controller from '@philips-emr/tws-core/lib/client';
import { ClickEvent } from '@philips-emr/tws-core/lib/component/types';
import { ModalService } from '@philips-emr/tws-core/lib/services';

import { ProductListAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

@Controller({ fragment: FragmentNames.PRODUCT_LIST })
export default class DiscreditedProvidersProductListController extends BaseController {

  @HPMSOnClickLink(Aliases.HPMS_PRODUCT_CUSTOM_LINK)
  onClickLink(event: ClickEvent): void {
    const nrSeqPlan = event.value as number;
    ModalService.openDefault({
      closeable: true,
      fragment: FragmentNames.PRODUCT_DATA,
      title: 'hi.product-information',
      contextData: { nrSeqPlan },
      theme: ThemeTonalRange.ULTRA_LIGHT,
    });
  }
}
